/**
 * AIAnalyzeDialog.applyAltitudeEstimateResult 와 동일 규칙 (뷰 없이 검증).
 * @param {{ altCorrectionValue?: number }|null|undefined} result
 * @returns {number|null} 채울 보정값
 */
export function resolveAppliedAltCorrection(result) {
  if (!result || !Number.isFinite(Number(result.altCorrectionValue))) {
    return null;
  }
  return Number(result.altCorrectionValue);
}
